<template>
  <div class="toolbar flex-column">
    <SuccessAndFail 
        :msjEnable.sync="msjEnable" 
        :mensajeDialog="mensaje" 
        :buttomAceptar="buttomAceptar"
        :buttomCancelar="buttomCancelar" 
        :icon.sync="iconModal" 
        @Aceptar="ClickAceptar" 
        :aceptar="aceptarLabel"
        :cancelar="cancelarLabel"
    />
    <TabView>
      <TabPanel header="Mis Actuaciones">
        <div class="header">
          <div>
            <TTableFilters 
                v-if="$offline.onlineMode" 
                ref="filtersRef" 
                apiversion="v2" 
                :dropdown="filterDropdown"
                :filtersFields="filtersFields" 
                :enableFilterMultiple="enableFilterMultiple" 
                @search="getData(true)"
                @cleanQuery="handleCleanQuery"
            />
          </div>
          <div>
            <SplitButton 
              v-if="$offline.onlineMode && splitItems.length > 0" 
              label="Descargar excel" 
              id="bottonXLS"
              :model="splitItems" 
            />
          </div>        
        </div>
        <DataTable
          :value="denunciationsToShow"
          :paginator="false"
          class="p-datatable-forms col-12"
          dataKey="id"
          :filters="filters"
          :loading="loading || disabledRowBotton"
          test-id="Denuncias"
        >
          <template #empty> No hay denuncias para mostrar. </template>
          <template #loading> Descargando, espere por favor. </template>

          <Column v-for="column in keyShow" :field="column.title" :key="column.title" :sortable="false"
            :sortField="column.fieldName" v-if="showColumnOrNot(column.title)">
            <template #header>
              <div class="flex align-items-center">
                {{ column.title }}
                <Button v-if="order[column.fieldName]" :icon="order[column.fieldName].icon || 'pi pi-sort-alt'"
                  class="p-button-rounded p-button-secondary p-button-text" @click="setOrderBy(column.fieldName)" />
              </div>
            </template>
            <template #body="slotProps">
              <div :test-id="'fila-nombre' + slotProps.index" :id="
                  !isOfflineDoc(slotProps.data)
                    ? slotProps.data.ActuacionUsuarioDependencia.find(
                        (e) => e.UsuarioID === 'Sin Usuario Asignado' && e.Fechahasta === null
                      )
                      ? 'sin-propietario'
                      : ''
                    : ''
                " class="flex align-items-center">
                <div class="flex mr-2">
                  <Button v-if="booleans(slotProps, 'triangleButton', column.title)" v-tooltip.left="
                      slotProps.data.Numero
                        ? 'No fue asignado ningún propietario'
                        : 'Falta numero de sumario'
                    " icon="pi pi-exclamation-triangle" class="p-button-rounded p-button-danger"
                    :test-id="'danger-' + slotProps.data.ActuacionID" />
                </div>
                <div :class="getClass(column, slotProps.data)">
                  {{ formatDoc(column.title, slotProps.data) }}
                </div>
              </div>
            </template>
          </Column>
          <Column class="flex-row">
            <template #body="slotProps">
              <div class="flex" style="text-align: right">
                <div class="flex mr-2" v-if="isOfflineDoc(slotProps.data) && $offline.onlineMode">
                  <Button 
                    v-tooltip.left="'Subir'" 
                    icon="pi pi-upload"
                    class="p-button-rounded p-button-success p-button-outlined" 
                    @click="subirActuacion(slotProps)" 
                />
                </div>
                <div v-if="booleans(slotProps, 'numeroExtracto')">
                    <Button 
                        v-tooltip.left="'Recientemente asignada'" 
                        label="Extracto de Denuncia"
                        icon="pi pi-check"
                        class="p-button-danger p-button-sm" 
                        test-id="'Asignar-numero' + slotProps.data.ActuacionID"
                        @click="OpenModalAddNsum(slotProps)" 
                        :style="{
                            height: '40px ',
                            width: '200px',
                            marginRight: '0.5rem ',
                        }" 
                    />
                </div>
                <div 
                    v-else-if="visibleButtons()"
                    class="flex justify-content-center align-items-center" 
                    style="width: 100%"
                >
                  <div class="action-buttons">
                    <Button
                        icon="pi pi-eye"
                        :disabled="disabledRowBotton"
                        class="p-button-text mb-2 action-button"
                        aria-label="Ver Actuación"
                        style="border: 1px solid #2196F3; border-radius: 100%;"
                        @click="seeActuacion(slotProps.data)"
                    />
                    <template> 
                        <div test-id="OptionsButton">
                            <SplitButton 
                                v-if="getItems(slotProps).length > 0"
                                :disabled="disabledRowBotton"
                                :model="getItems(slotProps)"
                                class="p-button-text mb-2 action-splitbutton"
                                appendTo="body"
                                style="border: 1px solid #5A5A5A; border-radius: 100%;"
                            />
                        </div>
                    </template>
                  </div> 
                </div>
                <div v-else class="flex">
                    <Button 
                        v-tooltip.left="'Vincular con esta Actuacion'" 
                        icon="pi pi-paperclip"
                        class="p-button-rounded p-button-outlined p-button-help"
                        :test-id="'vincular-act' + slotProps.data.ActuacionID"
                        @click="vincularActuacion(slotProps.data)" 
                    />
                </div>
              </div>
            </template>
          </Column>
          <template #footer v-if="$offline.onlineMode">
            <div class="flex justify-content-between">
              <div class="flex align-items-center">
                <span class="pagination">{{
                  `Mostrando registros del ${pagination.offset} al ${
                  pagination.offset + pagination.limit > total
                  ? total
                  : pagination.offset + pagination.limit
                  } de un total de ${total}`
                  }}</span>
              </div>
              <div class="align-self-center" :style="{ marginRight: '20%' }">
                <ul class="flex flex-row">
                  <Button icon="pi pi-angle-double-left" class="p-button-text" :disabled="pagination.actualPage <= 0"
                    @click="anterior('x2')" />
                  <Button icon="pi pi-angle-left" class="p-button-text" :disabled="pagination.actualPage <= 0"
                    @click="anterior()" />
                  <li v-for="(e, i) in pagination.indices" v-bind:key="i"
                    :style="{ textDecoration: 'none', listStyle: 'none' }">
                    <Button @click="goToPage(e - 1)" :style="
                        pagination.actualPage === e - 1
                          ? { backgroundColor: '#2196F3' }
                          : {
                              backgroundColor: 'transparent',
                              color: '#2196F3',
                              border: 'none',
                            }
                      ">{{ e }}</Button>
                  </li>
                  <Button icon="pi pi-angle-right" iconPos="right" class="p-button-text" test-id="nextButton" :disabled="
                      pagination.actualPage + 1 >= Math.ceil(total / pagination.limit)
                    " @click="siguiente()" />
                  <Button icon="pi pi-angle-double-right" iconPos="right" class="p-button-text" test-id="nextButton"
                    :disabled="
                      pagination.actualPage + 1 >= Math.ceil(total / pagination.limit)
                    " @click="siguiente('x2')" />
                </ul>
              </div>
              <div>
                <button disabled :style="{
                    backgroundColor: 'transparent',
                    cursor: 'normal',
                    border: 'none',
                  }"></button>
              </div>
            </div>
          </template>
        </DataTable>
      </TabPanel>
      <TabPanel header="Actuaciones Recibidas" v-if="mostrarActuacionesRecibidas">
        <ActuacionesRecibidas
            :formatDoc="formatDoc"
            :booleans="booleans"
            :isOfflineDoc="isOfflineDoc"
            :subirActuacion="subirActuacion"
            :OpenModalAddNsum="OpenModalAddNsum"
            :visibleButtons="visibleButtons"
            :getItems="getItems"
            :vincularActuacion="vincularActuacion"
            :getActuacionesUserByStationId="getActuacionesUserByStationId"
        />
      </TabPanel>
    </TabView>
    
    <Dialog :visible.sync="displayBasic" :style="{
        width: '30vw',
        height: '300px',
        backgroundClip: 'padding-box',
        backgroundColor: 'white',
      }" contentStyle="padding:0px"><template #header>
        <h4 :style="{ marginTop: '0px', marginBottom: '0px' }">
          Agregar un secretario a cargo
        </h4>
      </template>
      <div v-if="displayBasic">
        <form class="form-secretario">
          <div>
            <Dropdown id="dropdownActuaciones" v-model="dependenciaModal" :options="dependenciaList" filter
              :optionValue="'id'" optionLabel="dependencia" placeholder="Filtrar por dependencia...." :style="{
                position: 'absolute',
                left: '10%',
                top: '30%',
                minWidth: '80%',
              }" v-if="
                esTipoUsuario(['Super User', 'User Tester']) ||
                user.userdata.usuarioNombre == 'SuperUserE3'
              " test-id="dropdownNewSecretarioDependency" />
            <Dropdown 
                id="dropdownActuaciones" 
                v-model="secretario" 
                :options="
                    completeNullLabelsAndAddingID(
                    getActuacionesUserByStationId(dependenciaModal),
                    'apellido_nombre'
                    )
                "
                filter 
                optionLabel="apellido_nombre" 
                placeholder="Nombre del Oficial..." 
                :style="{
                    position: 'absolute',
                    left: '10%',
                    top: '50%',
                    minWidth: '80%',
                }"
                dataKey="id" 
                test-id="dropdownNewSecretario"
            >
              <template #item="slotProps">
                <div class="p-dropdown-car-value">
                  <div class="ml-2">{{ slotProps.item.nombre }}</div>
                </div>
              </template>
            </Dropdown>
          </div>
          <div class="field col" :style="{ paddingTop: '150px' }">
            <Button class="m-b-1" @click="AsignarSecretario" :disabled="disabledAsignarButton" test-id="buttonAsignar">
              Asignar
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
    <Dialog :visible.sync="dataExcel.showModal">
      <template #header>
        <h4 :style="{ marginTop: '0px', marginBottom: '0px' }">Descargar Excel</h4>
      </template>
      <div class="flex flex-column align-items-center justify-content-center">
        <ProgressSpinner v-if="dataExcel.loading" />
        <div v-else>
          <Button icon="pi pi-check" class="p-button-rounded p-button-outlined p-button p-component p-button-icon-only"
            :style="{
              color: 'green',
              borderRadius: '100%',
              border: 'solid 1px green',
            }" v-if="dataExcel.data.length > 0"></Button>
          <span v-else-if="!dataExcel.error">No hay sumarios para exportar</span>
        </div>
        <span v-if="dataExcel.loading && !dataExcel.error">El boton se habilitara una vez que se termine de cargar el
          excel...</span>
        <span v-if="dataExcel.error">{{ dataExcel.error }}</span>
      </div>
      <template #footer>
        <div class="flex justify-content-center">
          <JsonExcel :data="dataExcel.data" :fields="dataExcel.fields" default-value="----"
            :name="dataExcel.name + '.xls'" :disabled="dataExcel.loading || dataExcel.data.length == 0">
            <!-- <Button type="button" :disabled="dataExcel.loading ||  dataExcel.data.length==0" > -->
            <div :class="
                dataExcel.loading || dataExcel.data.length == 0
                  ? 'bg-blue-200 border-round p-3 select-none text-white'
                  : 'bg-primary p-3 cursor-pointer border-round select-none'
              ">
              Descargar {{ dataExcel.name }}
            </div>
            <!-- </Button> -->
          </JsonExcel>
        </div>
      </template>
    </Dialog>
    <ModalForm 
        :Show="showModalForm" 
        @sendInfo="addNsumario" 
        Title="Ingrese un Nro° de Sumario  " 
        :Inputs="Inputs"
        :OptionDisable="true" 
    />
    <ModalTemplate
        title="Confirmación" 
        type="confirmativo" 
        message="¿El hecho fue esclarecido?" 
        :showIcon="true"
        @cancel="closeModalTemplate(ModalRefConfirm)" 
        @confirm="confirm(ModalRefConfirm)" 
        :dismissableMask="true"
        severity="primary" 
        ref="ModalRefConfirm" 
    />
    <ModalTemplate 
        title="Información" 
        type="informativo"
        message="Debe cargar al menos 3 diligencias para finalizar la actuación" 
        :showIcon="true"
        @confirm="closeModalTemplate(ModalRefInform)" 
        severity="danger" 
        ref="ModalRefInform" />
    <ModalSucces 
      title="Eliminar actuación"
      icon="pi-question-circle"
      colorIcon="#D32F2F"
      message="¿Está seguro de que desea eliminar esta actuación? Esta acción es permanente y no se podrá deshacer."
      :showIcon="true"
      :dismissableMask="true"
      severity="danger"
      :closable="false"
      ref="ModalRefConfirmDelete"
    >
      <template #footer>
        <div class="w-full flex justify-content-end gap-2">
          <Button 
            label="Cancelar" 
            class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5" 
            @click="closeModalTemplate(ModalRefConfirmDelete)"
          />
          <Button 
            label="Eliminar" 
            class="border-round-lg w-5"
            style="background: #D32F2F;" 
            @click="deleteActuacion"
          />
        </div>
      </template>
    </ModalSucces>
  </div>
</template>

<script>
import axios from "axios";
import SplitButton from "primevue/splitbutton";
import JsonExcel from "vue-json-excel";
import { actuacionesConfig } from "@/router/RoutesConfig/actuacionesConfig/actuacionesConfig";
import ModalTemplate from "../../components/ModalTemplate.vue";
import ModalSucces from '@/components/ModalSucces';
import ActuacionesRecibidas from './ActuacionesRecibidas.vue'

import TTableFilters from "@/components/TTable/TTableFilters.vue";

import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { 
    useCommonMethods,
    useProsecutor,
    useActuacionesOrder,
    useSumariosToExcel,
    useActuacionFilters,
    useSumariosToExcel2,
    useToast,
    useOfflineCompat,
    useRouterCompat,
    useUserAccess,
    useStoreCompat,
} from "@/composables/index.js";

export default defineComponent({
    name: "SumarioHomePage",
    components: { 
        SplitButton, 
        JsonExcel, 
        TTableFilters, 
        ModalTemplate,
        ModalSucces,
        ActuacionesRecibidas
    },
    setup(props, { emit }) {
        const { router, route } = useRouterCompat();
        const store = useStoreCompat()
        const offline = useOfflineCompat();
        const { esTipoUsuario } = useUserAccess()
        const toast = useToast()
        
        const ClickAceptar = () => {}
        const aceptarLabel = ref(undefined)
        const cancelarLabel = ref(undefined)
        const CategoriaUfiID = store.state.user.userdata.CategoriaUfiID
        const iconModal = ref({})
        const buttomAceptar = ref({ buttom: true, action: true })
        const buttomCancelar = ref({ buttom: true, action: false })
        const msjEnable = ref(false)
        const mensaje = ref("")
        const err = ref(null)
        const showModalForm = ref({ show: false, ActuacionID: "" })
        const splitItems = ref([])
        const disabledRowBotton = ref(false)
        const actualDep = ref("")
        const showCalendar = ref(true)
        const secretario = ref("")
        const ActuacionUsuarioDependencia = ref("")
        const depModalSelected = ref(null)
        const displayBasic = ref(false)
        const filters = ref({})
        const isFiltered = ref(false)
        const customName = ref([])
        const data = ref(null)
        const customColumn = ref([])
        const actuacionType = ref(null)
        const routeID = ref(null)
        const filtersRef = ref(null)

        const keyShow = ref([
            { title: "Fecha de Creación", fieldName: "FechaCreacion" },
            { title: "N° de Actuacion", fieldName: "Numero" },
            { title: "Actuaciones", fieldName: "TiposumarioID" },
            { title: "Caratula/Causa", fieldName: "CausaCaratula" },
            { title: "Juzgado", fieldName: "nombreJuzgado" },
            { title: "Dependencia", fieldName: "Dependencia" },
            { title: "Estado", fieldName: "EstadoSumario" },
        ])
        const filterActuaciones = ref([
            { name: "Expedientes", value: "Expediente" },
            { name: "Sumarios", value: "Sumario" },
        ])
        const filterEstados = ref([
            { name: "En curso", value: "En Curso" },
            { name: "Vencida", value: "Vencida" },
            { name: "Finalizada", value: "Finalizada" },
        ])
        const filterDependencias = ref([{ name: "hoy", value: "" }])
        const actuacionesOfOptions = ref([
            { id: 0, option: "Mis registros" },
            { id: 1, option: "Dependencia Registros" },
        ])
        const actuacionesOf = ref({ id: 1, option: "Dependencia Registros" })
        const disabledAsignarButton = ref(true)
        const denunciationsToShow = ref([])
        const isUsuarioJefe = ref(false)
        const items = ref([])
        const filteredSecretario = ref(null)
        const permisosPorUsuario = {
            //UserAdmin
            "Usuario Admin": [
                "Agregar Diligencia",
                "Reasignar Secretario",
                "Finalizar Actuacion",
                "Eliminar Actuacion",
            ],
            "Super User": [
                "Agregar Diligencia",
                "Reasignar Secretario",
                "Finalizar Actuacion",
                "Eliminar Actuacion",
            ],
            "User Tester": [
                "Agregar Diligencia",
                "Reasignar Secretario",
                "Finalizar Actuacion",
                "Eliminar Actuacion",
            ],
            //UserDependencia
            "Jefe de Sumario": [
                "Agregar Diligencia",
                "Reasignar Secretario",
                "Finalizar Actuacion",
                "Eliminar Actuacion",
            ],
            "Jefe de Dependencia": [
                "Agregar Diligencia",
                "Reasignar Secretario",
                "Finalizar Actuacion",
                "Eliminar Actuacion",
            ],
            //oficial Sumariante
            "Oficial Sumariante": [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            //UserFiscal
            "Fiscal General": [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            Supervisor: [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            "Ayudante Fiscal": [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            UsuarioFiscal: [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            Fiscal: [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            Administrativo: [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            "Policia Investigador": [
                "Agregar Diligencia",
                "Finalizar Actuacion",
            ],
            //UserData
            "Control de Gestion": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ],
            "Dirección de Información para el Delito D-2": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ],
            "Dpto. Asuntos Judiciales D-5": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ],
            "Dpto. Planeamiento": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ],
            "Dpto.Criminalistica": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ],
            "Lab. Informatico Forense": [
                "Agregar Diligencia",
                "Reasignar Secretario",
            ]
        }
        const acciones = {
            "Agregar Diligencia": {
                label: "Agregar Diligencia",
                icon: "pi pi-plus-circle",
                command: (slotProps) => {
                    agregarDiligencia(slotProps);
                },
            },
            "Reasignar Secretario": {
                label: "Reasignar Secretario",
                icon: "pi pi-user-plus",
                command: (slotProps) => {
                    const actuacionUsuarioDependencia = slotProps.data.ActuacionUsuarioDependencia.find(
                    (e) =>
                        (e.UsuarioID === "Sin Usuario Asignado" && !e.Fechahasta) || !e.Fechahasta
                    );
                    if (actuacionUsuarioDependencia) {
                        // Llamamos directamente a assignSecretary pasando los valores correctos
                        assignSecretary(actuacionUsuarioDependencia, slotProps.data);
                    } else {
                        console.warn("No se encontró ningún Usuario asignado o Fechahasta no está definida");
                    }
                },
            },
            "Finalizar Actuacion": {
                label: "Finalizar Actuacion",
                icon: "pi pi-check-square",
                command: (slotProps) => {
                    finalizarActuacion(slotProps);
                },
            },
            "Eliminar Actuacion": {
                label: "Eliminar Actuacion",
                icon: "pi pi-trash",
                command: (slotProps) => {
                    openDeleteModal(slotProps);
                },
            },
        }    
        const Inputs = ref([
            {
                type: "input",
                name: "NumeroSumario",
                typeI: "number",
                label: "Numero de sumario",
            },
            {
                type: "dropdown",
                options: [
                    {
                        value: new Date().getFullYear(),
                        name: JSON.stringify(new Date().getFullYear()).substr(-2),
                    },
                    {
                        value: new Date().getFullYear() - 1,
                        name: JSON.stringify(new Date().getFullYear() - 1).substr(-2),
                    }
                ],
                name: "year",
                typeI: "number",
                placeholder: "Año",
                label: "Año",
                valueDrop: {},
            },
        ])
        const forms = [
            {
                name: "Sumario Prevencional por denuncia",
                link: "/sumario/denuncia/formulario",
            },
        ]

        const ModalRefConfirm = ref(null)
        const ModalRefInform = ref(null)
        const ModalRefConfirmDelete = ref(null)
        const selectedActuacion = ref(null)

        const getActuacionesUserByStationId = (dependenciaId = null) => {
            return store.getters['user/getActuacionesUserByStationId'](dependenciaId)
        }
        const oficialesList = computed(() => store.getters['sumarioList/getOficiales'])
        const oficialesListModal = computed(() => store.getters['sumarioList/getOficialesModal'])
        const dependenciaList = computed(() => store.getters['siis/getDependecias'])
        const denunciations = computed(() => store.getters['sumarioList/getList'])
        const total = computed(() => store.getters['sumarioList/getTotal'])
        const pagination = computed(() => store.getters['sumarioList/getPagination'])
        const resumen = computed(() => store.getters['sumario/dataResumen'])

        const sumario = computed(() => store.state.sumario)
        const tablasListadas = computed(() => store.state.sumarioList.tablasListadas)
        const contPag = computed(() => store.state.sumarioList.contPag)
        const formType = computed(() => store.state.sumario.formType)
        const loading = computed(() => store.state.sumarioList.loading)
        const user = computed(() => store.state.user)
        const viewData = computed(() => store.state.sumarioViews)

        const lastUrl = computed({
            get: () => store.state.sumarioList.lastUrl,
            set: (value) => store.dispatch('sumarioList/setLastUrl', value)
        })

        const {
            filtersFields,
            filterDropdown,
            initFilters,
            enableFilterMultiple,
            preloadDropdownOptionsFromQuery 
        } = useActuacionFilters(getActuacionesUserByStationId)

        const dependenciaModal = computed({
            get: () => depModalSelected.value ?? user.value.userdata.dependenciaID,
            set: (value) => { depModalSelected.value = value }
        })

        const depOption = computed({
            get: () => store.state.sumarioList.depSelected,
            set: async (value) => {
                await store.dispatch('sumarioList/setDepSelected', value)
            }
        })

        const rangoFecha = computed({
            get: () => store.state.sumarioList.rangoFechas,
            set: async (value) => {
                await store.dispatch('sumarioList/setRangoFecha', value)
            }
        })

        const filterField = computed({
            get: () => store.state.sumarioList.filterField,
            set: (v) => {
                isFiltered.value = true
                store.dispatch('sumarioList/setFilterField', v)
            }
        })

        const dataActuacionesOf = computed({
            get: () => actuacionesOf.value,
            set: async (v) => {
                if (v === 'Mis registros') {
                    actuacionesOf.value = { id: 0, option: 'Mis registros' }
                    await store.dispatch('sumarioList/updateUserId', user.value.uid)
                } else {
                    actuacionesOf.value = { id: 1, option: 'Dependencia Registros' }
                    await store.dispatch('sumarioList/updateUserId', '')
                }
                await getData()
                return actuacionesOf.value
            }
        })

        const filterDropdownOptions = computed(() => {
            let options = [
                { name: "Expedientes", value: "Expediente" },
                { name: "Sumarios", value: "Sumario" },
                { name: "UFI", value: "UNIDAD" },
                { name: "Actuaciones Preliminares - TODAS", value: "Actuacion Preliminar" },
                { name: "UFI Delitos Especiales - TODOS", value: "Unidades Fiscales de Investigacion D.E"},
            ];
            for (const actuationName in viewData.value) {
                const filterName = Object.keys(viewData.value[actuationName]?.filters || {})[0]
                options.push({
                    name: filterName,
                    value: viewData.value[actuationName]?.filters?.[filterName]?.actuacionesFilters?.value
                })
            }
            options = options.filter(
                (obj) => !Object.values(obj).some((value) => value === undefined)
            );
            return user.value.userdata.claseDeUsuario === 'UsuarioFiscal'
                ? generateFilterOptionsForFiscalUser(options)
                : options
        })

        watch(secretario, (newValue) => {
            if (newValue !== "") {
                disabledAsignarButton.value = false;
            } else {
                disabledAsignarButton.value = true;
            }
        })

        onMounted(async () => {
            initFilters()
            initProsecutor()
            setXLSDropdown();
            filterDropdown.value["exp_pre_TipoActuacion.TipoActuacionID"].options = filterDropdownOptions.value;
            isUsuarioJefe.value = esTipoUsuario(['Super User', 'Jefe de Sumario', 'Jefe de Dependencia'])
            store.dispatch("siis/setDependencias");

            if (esTipoUsuario(["Oficial Sumariante"])) {
                await store.dispatch("sumarioList/updateUserId", user.value.uid);
                dataActuacionesOf.value = "Mis registros";
                await getData();
            } else if (!esTipoUsuario(["Dpto. Asuntos Judiciales D-5", "Dpto.Criminalistica", "Lab. Informatico Forense"])) {
                await getData();
                if (offline.onlineMode) {
                    if (!esTipoUsuario(["Deposito Judicial", "Juez", "Ayudante de Juez"])) {
                    toast.success("Cargando los sumarios sin propietario actual...");
                    store.dispatch("sumarioList/setSumariosSinSecretario", user.value.userdata.dependenciaID)
                        .then(() => { })
                        .catch((e) => {
                            console.error(e);
                            toast.error("No se pudieron cargar los sumarios sin secretario actual");
                        });
                    }
                }
            } else {
                await getData();
            }
            // Si hay filtros en la query, restaurarlos
            if (route.query?.filtros) {
                await preloadDropdownOptionsFromQuery(route.query.filtros);
                filtersRef.value?.setFiltersFromQuery(route.query.filtros);
                return; 
            }
            
        })

        const getItems = (slotProps) => {
            const tipoUsuario = user.value.userdata.tipoUsuario;
            const estadoActuacion = slotProps.data.EstadoSumario;
            const esFinalizada = estadoActuacion === "Finalizada";
            if (permisosPorUsuario[tipoUsuario]) {
                return permisosPorUsuario[tipoUsuario]
                .filter((accion) => !(accion === "Finalizar Actuacion" && esFinalizada))
                .map((accion) => {
                    return {
                        ...acciones[accion],
                        command: () => {
                            acciones[accion].command(slotProps);
                        },
                    };
                });
            } else {
                console.warn(`El tipo de usuario ${tipoUsuario} no tiene permisos definidos.`);
                return [];
            }
        }

        const finalizarCambioEstado = (msj, icon, mensajeEnable = false, error = false, routerPush) => {
            aceptarLabel.value = undefined;
            cancelarLabel.value = undefined;
            buttomCancelar.value = { buttom: false, action: false };
            buttomAceptar.value = { buttom: true, action: false, routerPush };
            iconModal.value = icon;
            err.value = error;
            mensaje.value = mensaje;
            msjEnable.value = mensajeEnable;
        }

        const confirm = async () => {
            let data = {
                NuevoEstado: "Finalizada",
                Esclarecido: true,
            };
            try {
                let request = await axios.put(
                    `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/estado-actuacion/${sumario.value.id}`,
                    data,
                    { withCredentials: true, params: { method: "own" } }
                );
                if (request.data.error === "") {
                    let iconModal = {
                        type: "pi pi-check-circle",
                        style: "font-size: 3em; color: rgb(89, 150, 29);",
                    };
                    let mensaje = "La Actuacion Se Finalizo con Exito";
                    finalizarCambioEstado(
                        mensaje,
                        iconModal,
                        true,
                        false,
                        "/actuaciones/list"
                    );
                }
            } catch (e) {
                let iconModal = {
                    type: "pi pi-exclamation-circle",
                    style: "font-size: 3em; color: red;",
                };
                let mensaje = "La Actuacion No se pudo Finalizar";
                finalizarCambioEstado(mensaje, iconModal, true, true);
            }
        }
    
        const agregarDiligencia = async (data) => {
            disabledRowBotton.value = true;
            await store.dispatch("sumario/setSumario", data.data.ActuacionID);
            disabledRowBotton.value = false;
            changeNameInStore(formType.value);
            if (actuacionType.value) {
                router.push(
                    `/actuaciones/new/${actuacionType.value}/${sumario.value.id}/addDiligencia`
                );
            } else {
                console.log("No se pudo encontrar un pathName para formType:", formType.value);
            }
        }

        const reasignarSecretario = (data) => {
            const actuacionUsuarioDependencia = data.ActuacionUsuarioDependencia.find(
                (e) => (e.UsuarioID === "Sin Usuario Asignado" && !e.Fechahasta) || !e.Fechahasta
            );
            disabledRowBotton.value = true;
            if (actuacionUsuarioDependencia) {
                assignSecretary(null, actuacionUsuarioDependencia, data);
            } else {
                console.warn("No se encontró ningún Usuario asignado o Fechahasta no está definida");
            }
            disabledRowBotton.value = false;
        }

        const openModalTemplate = (type) => {
            type.value?.open();
        }

        const closeModalTemplate = (type) => {
            if(type.value){
                type.value?.close();
            }else{
                type.close()
            }
        }

        const finalizarActuacion = async (data) => {
            disabledRowBotton.value = true;
            await store.dispatch("sumario/setSumario", data.data.ActuacionID);
            disabledRowBotton.value = false;
            if (sumario.value?.diligencia.length >= 3) {
                openModalTemplate(ModalRefConfirm);
            } else {
                openModalTemplate(ModalRefInform);
            }
        }

        const vincularActuacion = async (data) => {
            const { id } = route.params;
            if (id) routeID.value = id;
            try {
                let objeto = {
                    SumarioID: data.SumarioID,
                    DepositoArticuloID: routeID.value,
                    NumeroActuacion: data.Numero,
                    JuzgadoInterviniente:
                        data["Roljuzgadoactuacion"] != undefined
                        ? data.Roljuzgadoactuacion.Nombre
                        : data["Sumarioufi"] != undefined
                            ? "UFI N° " + data.Sumarioufi[0].Numero
                            : "",
                    Caratula:
                        data["Actuacioncausacaratula"] != undefined
                        ? data["Actuacioncausacaratula"].map((element) => element.Nombre).toString()
                        : data["ActuacionArticulo"] != undefined
                            ? data["ActuacionArticulo"]
                            .map((element) => element.Numeroarticulo)
                            .toString()
                            : "",
                    DependenciaActuacion: data.DependenciaLetra,
                    TipoActuacion: data.TiposumarioID,
                    EstadoActuacion: data.Estado,
                    ActuacionID: data.ActuacionID,
                    Fecha: data.FechaCreacion,
                };
                store.commit("sumarioList/loadingUpdate", true);
                store.dispatch("siis/setVinculatedActuations", objeto);
                store.commit("sumarioList/loadingUpdate", false);
                // Con la siguiente línea de codigo cerramos la ventana
                emit("selectItem");
            } catch (e) {
                console.log(e);
                toast.error("ERROR: La vinculacion no se pudo realizar");
            }
        }

        const mostrarActuacionesRecibidas = computed(() => {
            return esTipoUsuario(['Super User', 'Jefe de Sumario', 'Jefe de Dependencia'])
        });

        const visibleButtons = () => {
            if (route.path.includes("deposito")) {
                return false;
            }
            return true;
        }

        const setXLSDropdown = () => {
            if (esTipoUsuario(["Super User", "User Tester", "Super Usuario de E3", "Jefe de Sumario", "Jefe de Dependencia"])) {
                splitItems.value.push({
                    label: "Planilla del Delito",
                    command: () => {
                        // Planilla del delito solia ser "Planeamiento" pero se solicito se cambie, para asi poder ser usada tambien por Asuntos Judiciales D-5
                        downloadXls2("Planilla del Delito");
                    }
                });
                splitItems.value.push(
                    {
                        label: "Inspección y Control",
                        command: () => {
                            downloadXls("Inspección y Control");
                        }
                    },
                    {
                        label: "Estadística de Registros", //se pidio que cambi el nombre, pero el funcionamiento sigui siendo el de Telecomunicaciones d-8
                        command: () => {
                            downloadXls("Estadística de Registros");
                        }
                    }
                )
            } else if (esTipoUsuario(["Control de Gestion"], store.state.user)) {
                splitItems.value.push({
                    label: "Inspección y Control",
                    command: () => {
                        downloadXls("Inspección y Control");
                    }
                });
            } else {
                splitItems.value.push({
                    label: "Planilla del Delito",
                    command: () => {
                        downloadXls2("Planilla del Delito");
                    }
                });
            }
        }

        const getClass = (column, sumario) => {
            if (column.title == "Estado") {
                switch (sumario.Estado) {
                case "En Curso":
                    return "bg-green-200 min-w-full flex justify-content-center white-space-nowrap p-1 font-medium text-green-800 border-round";
                case "Vencida":
                    return "bg-yellow-200 min-w-full flex justify-content-center white-space-nowrap p-1 font-medium text-yellow-800 border-round";
                case "Finalizada":
                    return "custom-bg-red-200 min-w-full flex justify-content-center white-space-nowrap p-1 font-medium custom-text-red-800 border-round";
                }
            }
        }
        
        const goToPage = async (page) => {
            await store.dispatch(
                "sumarioList/updateOffset",
                page * pagination.value.limit
            );
            await store.dispatch("sumarioList/get");
            denunciationsToShow.value = await denunciations.value
        }

        const hasSecretary = (slotProps) => {
            return !slotProps.data.ActuacionUsuarioDependencia.find(
                (e) => e.UsuarioID === "Sin Usuario Asignado" && e.Fechahasta === null
            );
        }

        const booleans = (slotProps, esPara, title) => {
            if (esPara == "triangleButton"){
                return (
                    (!isOfflineDoc(slotProps.data) &&
                        slotProps.data.ActuacionUsuarioDependencia.find(
                            (e) => e.UsuarioID === "Sin Usuario Asignado" && e.Fechahasta === null
                        ) &&
                        title == "Fecha de Creación") ||
                    (!slotProps.data.Numero &&
                        hasSecretary(slotProps) &&
                        title == "Fecha de Creación") 
                    //   ||
                    // (this.getUsAct(slotProps)?.RecienEnviada == 1 &&
                    //   title == "Fecha de Creación" &&
                    //   this.getUsAct(slotProps).NombreUsuario === this.user.userdata.usuarioNombre)
                    //esto se comento para comprobar la utilidad del campo RecienEnviada de actuacionUsuarioDependencia
                );
            }
            if ((esPara = "numeroExtracto")){
                return (
                    (!isOfflineDoc(slotProps.data) &&
                    !slotProps.data.Numero &&
                    hasSecretary(slotProps)) 
                    //   ||
                    // (this.getUsAct(slotProps)?.RecienEnviada == 1 &&
                    //   this.getUsAct(slotProps).NombreUsuario === this.user.userdata.usuarioNombre)
                    // //esto se comento para comprobar la utilidad del campo RecienEnviada de actuacionUsuarioDependencia
                );
            }
        }

        const addNsumario = async (res) => {
            if (offline.onlineMode) {
                let numero = res.NumeroSumario + "/" + res.year.toString().slice(-2);
                let sumarioID = showModalForm.value.sumario.ActuacionID;
                let url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/sumario/${sumarioID}`;
                try {
                    await axios.put(
                        url,
                        { ...showModalForm.value.sumario, Numero: numero },
                        { withCredentials: true, params: { method: "methodCommon" } }
                    );
                    await getData();
                } catch (error) {
                    console.error(error);
                    toast.error("No se pudo cargar el numero de sumario");
                }
                // cambio el recien enviado del usuario sumario , esto lo uso para traerlos  al inicio de la bandeja
                let uSumario = getUsAct(
                    store.state.sumarioList.list.find((e) => e.ActuacionID === sumarioID)
                );
                if (uSumario && uSumario["cambioRecienEnviada"]) {
                    uSumario["cambioRecienEnviada"] = true;
                    uSumario.RecienEnviada = "0";
                }
                try {
                    await axios.put(
                        `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia/${uSumario.ActuacionUsuarioDependenciaID}`,
                        uSumario,
                        { withCredentials: true, params: { method: "own" } }
                    );
                    //  cambio el numero en el sumario directamente para no tenes que traerlo de la base de datos y permanece primero para que el usuario lo vea
                    store.state.sumarioList.list.find(
                        (e) => e.ActuacionID === sumarioID
                    ).Numero = numero;
                } catch (error) {
                    console.error(error);
                }
            } else {
                toast.error("No se puede realizar esta acción sin conexión a internet");
            }
        }
        
        const OpenModalAddNsum = async (sumario) => {
            if (offline.onlineMode) {
                sumario = sumario.data;
                let uSumario = getUsAct(sumario);
                // este solo cambia el  RecienEnviada si ya tiene numero de sumario
                if (uSumario?.RecienEnviada === "1" && sumario.Numero) {
                    uSumario["cambioRecienEnviada"] = true;
                    uSumario.RecienEnviada = "0";
                    try {
                        await axios.put(
                            `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia/${uSumario.ActuacionUsuarioDependenciaID}`,
                            uSumario,
                            { withCredentials: true, params: { method: "own" } }
                        );
                    } catch (e) {
                        console.error(e);
                    }
                    store.state.sumarioList.list
                        .find((e) => e.ActuacionID === uSumario.ActuacionID)
                        .ActuacionUsuarioDependencia.find(
                            (e) => e.Fechahasta === null
                        ).RecienEnviada = 0;
                }
                if (!sumario.Numero) {
                    showModalForm.value.show = true;
                    showModalForm.value.sumario = {
                        ActuacionID: sumario.ActuacionID,
                        DenunciaID: sumario.DenunciaID,
                        DependenciaID: sumario.DependenciaID,
                        FechaCreacion: sumario.FechaCreacion,
                        TiposumarioID: sumario.TiposumarioID,
                    };
                }
            } else {
                toast.error("No se puede realizar esta acción sin conexión a internet");
            }
        }


        const isOfflineDoc = (doc) => {
            //Cuando genero el excel para planeamiento doc es undefined, por eso se hizo el siguiente if/else
            if (doc?.ActuacionID) {
                return doc["ActuacionID"].search("offline-") === 0;
            } else {
                return false;
            }
        }
        
        // trae la data del oficial actual (y el ActuacionUsuarioDependencia)
        const getUsAct = (slotProps) => {
            if (isOfflineDoc(slotProps.data)) return "Offline";
            return slotProps.data
                ? slotProps.data.ActuacionUsuarioDependencia.find((e) => e.Fechahasta === null)
                : slotProps.ActuacionUsuarioDependencia.find((e) => e.Fechahasta === null);
        }

        const AsignarSecretario = async () => {
            ActuacionUsuarioDependencia.value.UsuarioID = secretario.value.UsuarioID;
            ActuacionUsuarioDependencia.value.DependenciaID = secretario.value.DependenciaID;
            if (actualDep.value !== ActuacionUsuarioDependencia.value.DependenciaID) {
                ActuacionUsuarioDependencia.value.CambioDep = 1;
                ActuacionUsuarioDependencia.value["UpdatePrevious"] = {
                    DependenciaID: actualDep.value,
                };
            }
            let fechaYhoraActual = new Date();
            let fecha = fechaYhoraActual.toISOString().slice(0, 10).replace("T", " ");
            //separamos la hora y le sumamos +3 horas que se restan por la zona horaria
            let dia = new Date(fechaYhoraActual);
            let hora = dia.getHours() + ":" + dia.getMinutes() + ":" + dia.getSeconds();
            //unimos hora y fecha
            fechaYhoraActual = fecha + " " + hora;
            
            ActuacionUsuarioDependencia.value.Fechadesde = fechaYhoraActual;

            displayBasic.value = false;
            store.commit("sumarioList/loadingUpdate", true);
            ActuacionUsuarioDependencia.value.RecienEnviada = "1";
            await axios.put(
                `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia/${ActuacionUsuarioDependencia.value.ActuacionUsuarioDependenciaID}`,
                ActuacionUsuarioDependencia.value,
                { withCredentials: true, params: { method: "own" } }
            );
            store.commit("sumarioList/loadingUpdate", false);
            secretario.value = null;
            await getData();
        }

        const subirActuacion = async (doc) => {
            store.dispatch("sumarioList/loadingUpdate", true);
            await store.dispatch("sumario/setSumario", doc.data.ActuacionID);
            setTimeout(async () => {
                await store.dispatch("sumario/saveDenuncia");
                getData();
            }, 300);
        }

        const fechaMethod = (value) => {
            let date = new Date();
            let day = date.getDate();
            day = day < 10 ? "0" + day : day;
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            let year = date.getFullYear();
            if (value === "hoy") {
                value = [year, month, day].join("/");
            }
            if (value === "ultimoMes") {
                if (day <= 30) {
                    let diasfaltantes = day - 30;
                    month -= 1;
                    day = 30 + diasfaltantes;
                    month = month < 10 ? "0" + month : month;
                } else {
                    day -= 30;
                    day = day < 10 ? "0" + day : day;
                }
                value = [year, month, day].join("/");
            }
            if (value === "clear") {
                value = null;
            }
            return store.dispatch("sumarioList/setRangoFecha", value);
        }

        const assignSecretary = (idUsuarioSum, sumario) => {
            actualDep.value = sumario.DependenciaID;
            ActuacionUsuarioDependencia.value = idUsuarioSum;
            ActuacionUsuarioDependencia.value.Numeroextracto = ActuacionUsuarioDependencia.value.Numeroextracto
                ? ActuacionUsuarioDependencia.value.Numeroextracto
                : sumario.Numero;
            displayBasic.value = true;
        }

        const filterSecretario = (event) => {
            filteredSecretario.value = filteredSecretario.filter(
                (item) => item.nombre.toLowerCase().search(event.query.toLowerCase()) >= 0
            );
        }

        const changeNameInStore = (formType) => {
            const viewConfig = actuacionesConfig.find(
                (config) => config.path === "/actuaciones/view/"
            );
            if (viewConfig && viewConfig.actuaciones) {
                const foundActuacion = viewConfig.actuaciones.find(
                    (actuacion) => actuacion.nameInStore === formType
                );

                if (foundActuacion) {
                    actuacionType.value = foundActuacion.pathName;
                } else {
                    console.log(
                        "No se encontró ninguna coincidencia para el formType proporcionado en /actuaciones/view/."
                    );
                    actuacionType.value = null;
                }
            } else {
                console.log("No se encontró la configuración para /actuaciones/view/.");
            }
        }

        const seeActuacion = async (actuacion) => {
            const search = await filtersRef.value.getFiltersV2();
            router.push({
                path: `/actuaciones/view/${actuacion.ActuacionID}`,
                query: {
                    filtros: search.search
                }
            });
        }
        
        const openDeleteModal = (doc) => {
            selectedActuacion.value = doc;
            ModalRefConfirmDelete.value.open();
        };
        
        const deleteActuacion = async () => {
            ModalRefConfirmDelete.value.close();
            if (!selectedActuacion.value) return;
            
            try {
                store.dispatch("sumarioList/loadingUpdate", true);
                const actuacionId = selectedActuacion.value.data.ActuacionID;
                
                const resp = await store.dispatch(
                "sumario/deleteActuacion",
                actuacionId
                );

                if (resp === true) {
                    store.dispatch("sumarioList/deleteActuaciones", actuacionId);
                    denunciationsToShow.value = denunciations.value;
                    toast.success("Actuación eliminada correctamente");
                }
            } catch (error) {
                console.error("Error eliminando actuación:", error);
                toast.error("No se pudo eliminar la actuación. Intente nuevamente");
            } finally {
                store.dispatch("sumarioList/loadingUpdate", false);
                selectedActuacion.value = null;
            }
        };
        
        const authorizedUser = () => {
            //si el usuario es el SuperUserE3 que pueda verlos
            let tiposUserAutorizados = [
                "Super Usuario de E3",
                "Super User",
                "User Tester",
                "Jefe de Dependencia",
                "Jefe de Sumario",
            ];
            if (tiposUserAutorizados.includes(user.value.userdata.tipoUsuario)) {
                return true;
            } else {
                return false;
            }
        }

        const siguiente = (mod) => {
            mod == "x2"
                ? store.dispatch("sumarioList/get", { accion: "siguientex2" })
                : store.dispatch("sumarioList/get", { accion: "siguiente" })
        }
        
        const anterior = (mod) => {
            mod == 'x2'
                ? store.dispatch("sumarioList/get", { accion: "anteriorx2" })
                : store.dispatch("sumarioList/get", { accion: "anterior" })
        }

        const getData = async (fromSearch) => {
            let search = {}

            if (offline.onlineMode && fromSearch) {
                search = await filtersRef.value.getFiltersV2();
            }

            if (isUsuarioJefe.value) {
                const jefeFilters = {
                  //  "exp_pre_Actuacion.Numero": [{ operator: "IS NOT NULL", value: null }],
                    //"exp_pre_ActuacionUsuarioDependencia.UsuarioID": [{ operator: "IS NOT NULL", value: null }]
                };
                if (!search || typeof search.search !== "string") {
                    search.search = JSON.stringify(jefeFilters);
                } else {
                    const parsed = JSON.parse(search.search);
                    for (const key in jefeFilters) {
                        if (!parsed.hasOwnProperty(key)) {
                            parsed[key] = jefeFilters[key];
                        }
                        if(parsed.RolesOficiales || parsed.propietario ){
                           delete parsed["exp_pre_ActuacionUsuarioDependencia.UsuarioID"];
                        }
                    }

                    search.search = JSON.stringify(parsed);
                }
            }

            await store.dispatch("sumarioList/setSearch", search.search);
            await store.dispatch("sumarioList/get", { accion: "inicio" });
            denunciationsToShow.value =  denunciations.value
        }

        const formatDocOffline = (col, data) => {
            try {
                switch (col) {
                    case "Fecha de Creación":
                        let fechaDelHecho = "";
                        if (data.FechaCreacion) {
                            return data.FechaCreacion;
                        }
                        //si tenemos fecha desde y fecha hasta.. incluimos ambas
                        if ( data.Hecho[1].Fechahoradesde != "" && data.Hecho[1].Fechahorahasta != "" ) {
                            fechaDelHecho =
                                data.Hecho[1].Fechahoradesde.slice(0, -8) +
                                " / " +
                                data.Hecho[1].Fechahorahasta.slice(0, -8);
                        } else {
                            //si fechaDelHecho aun no se cargo, vemos cual de las 2 fecha se cargaron
                            if (data.Hecho[1].Fechahoradesde != "") {
                                fechaDelHecho = data.Hecho[1].Fechahoradesde.slice(0, -8);
                            } else if (data.Hecho[1].Fechahorahasta != "") {
                                fechaDelHecho = data.Hecho[1].Fechahorahasta.slice(0, -8);
                            }
                        }
                        return fechaDelHecho;
                    case "Actuaciones":
                        return data.Sumario.TiposumarioID;
                    case "Caratula/Causa":
                        //en el caso de que no tenga caratula, es por que se trata de un expediente, el cual cuenta con articulos
                        if (data.Sumario.CausaCaratula == "") {
                            //como aun dataResumen no fue cargado, tenemos que generar los articulos a mostrar
                            let Articulos = "";
                            for (let i in data.ActuacionArticulo.ArticulosID) {
                                Articulos =
                                Articulos == ""
                                    ? data.ActuacionArticulo.ArticulosID[i].Numeroarticulo
                                    : Articulos +
                                    ", " +
                                    data.ActuacionArticulo.ArticulosID[i].Numeroarticulo;
                            }
                            return Articulos;
                        } else return data.Sumario.CausaCaratula;
                    case "Juzgado":
                        return data.Juzgadointerviniente.Nombre;
                    case "N° de Actuacion":
                        return data.Sumario.Numero;
                    case "Estado":
                        return "Offline";
                    }
            } catch (e) {
                console.error("formatDocOffline err", col, data, e);
                return "";
            }
        }

        const formatDoc = (col, data) => {
            try {
                if (!offline.onlineMode || data.ActuacionID.search("offline-") == 0) {
                    return formatDocOffline(col, data);
                }
                switch (col) {
                    case "Fecha de Creación":
                        if (data.FechaCreacion != null) {
                            return data.FechaCreacion.slice(0, -8);
                        }
                        return "Sin datos";
                    case "Actuaciones":
                        const actuationTypeFound = Object.values(store.state.sumarioViews).find(
                                (item) => item?.actuationName?.[data.TiposumarioID] !== undefined
                            );
                        const nombreDelTipoDeActuacion =
                            actuationTypeFound !== undefined
                                ? actuationTypeFound?.actuationName?.[data.TiposumarioID]
                                : data.TiposumarioID;
                        data._nombreTipoActuacion = nombreDelTipoDeActuacion
                        return nombreDelTipoDeActuacion;
                    case "Caratula/Causa":
                        //en el caso de que no tenga caratula, es por que se trata de un expediente, el cual cuenta con articulos
                        if (data?.CausaCaratula == null || data?.CausaCaratula == "") {
                        //como aun dataResumen no fue cargado, tenemos que generar los articulos a mostrar
                        if (data["ActuacionArticulo"] ? data.ActuacionArticulo.length !== 0 : false) {
                            let Articulos = "";
                            for (let item of data.ActuacionArticulo) {
                                Articulos =
                                    Articulos == ""
                                    ? item.Numeroarticulo
                                    : Articulos + ", " + item.Numeroarticulo;
                            }
                            return Articulos;
                        }
                        if (
                            data["Actuacioncausacaratula"]
                            ? data.Actuacioncausacaratula.length !== 0
                            : false
                        ) {
                            let MultipleCausaCaratula = "";
                            for (let item of data.Actuacioncausacaratula) {
                                MultipleCausaCaratula =
                                    MultipleCausaCaratula == ""
                                    ? item.Nombre
                                    : MultipleCausaCaratula + ", " + item.Nombre;
                            }
                            return MultipleCausaCaratula;
                        }
                            return "Sin datos";
                        } else return data.CausaCaratula;
                    case "Juzgado":
                        let juzgado 
                        const tipoAct = data._nombreTipoActuacion?.toLowerCase() || "";
                        if (data.Roljuzgadoactuacion?.Nombre !== undefined) {
                            juzgado = data.Roljuzgadoactuacion.Nombre;
                        } else if (data.Actuacionufi !== undefined) {
                            juzgado = "UFI N°" + data.Actuacionufi[0].Numero;
                        } else if (tipoAct.includes("preliminar")) {
                            juzgado = data.DependenciaLetra || data.DependenciaNombre;
                        }else {
                            juzgado = "Sin datos";
                        }
                        return juzgado || "Sin datos";
                    case "N° de Actuacion":
                        return data.Numero !== "" ? data.Numero : "Sin datos";
                    case "Estado":
                        if(data["EstadoSumario"] !== undefined){
                            data["EstadoSumario"] = data["Estado"] ? data.Estado : "Sin datos";
                            return data.EstadoSumario !== "Sin datos" ? data.EstadoSumario.toUpperCase() : "Sin datos";
                        } 
                        return data["Estado"] ? data.Estado.toUpperCase() : "Sin datos";
                    case "Dependencia":
                        return data.DependenciaLetra || data.DependenciaNombre;
                    default:
                        return "";
                    }
            } catch (e) {
                console.error("formatDoc err", col, data, e);
                return "";
            }
        }
    
        const setStates = () => {
            store.dispatch("sumario/resetState");
            router.push("/nueva");
        }
    
        const getCausaCaratula = (data) => {
            return data.causaCaratula ? data.causaCaratula.nombre : "";
        }

        const getformType = (data) => {
            return data.formType ? data.formType : "";
        }

        const getDate = (date) => {
            const d = new Date(date);
            return d.toLocaleDateString();
        }
    
        const getDendunciante = (data) => {
            if (data.list.length > 1) {
                return data.list[0].doc.apellido + ", " + data.list[0].doc.nombre;
            } else {
                return "DENUNCIANTE ANONIMO";
            }
        }

        const completeNullLabelsAndAddingID = (originalArray, labelProp) => {
            let arrayCopy = [];
            for (let i = 0; i < originalArray.length; i++) {
                arrayCopy.push({ ...originalArray[i] });
                arrayCopy[i].id = i;
                if (arrayCopy[i][labelProp] === null) {
                    arrayCopy[i][labelProp] = "sin datos";
                }
            }
            return arrayCopy;
        }

        const showColumnOrNot = (columnTitle) => {
            let show = true;
            if (columnTitle === "Dependencia") {
                show = esTipoUsuario(
                [
                    "Super User",
                    "User Tester",
                    "Dirección de Información para el Delito D-2",
                    "Dpto. Planeamiento",
                    "Dpto. Asuntos Judiciales D-5",
                    "Dpto.Criminalistica",
                    "Lab. Informatico Forense",
                    "Control de Gestion",
                    "Juez",
                    "Ayudante de Juez",
                ]);
            }
            if (columnTitle === "Juzgado") {
                show = !esTipoUsuario(["Juez", "Ayudante de Juez"]);
            }
            if (columnTitle === "Denunciante") {
                show = !esTipoUsuario(["Super User", "User Tester"]);
            }
            return show;
        }
        
        const generateFilterOptionsForFiscalUser = (options) => {
            if (CategoriaUfiID.value === "ufis-todas") {
                let onlyUFIs = options.filter((option) => option.name.includes("UFI"));
                return onlyUFIs;
            } else {
                filtersFields.value = filtersFields.value.filter(
                    (filter) => filter.name !== "Actuaciones"
                );
                filtersRef.value.field = filtersFields.value[0];
                return [];
            }
        }

        const handleCleanQuery = () => {
            router.replace({ query: '' });
        }
        
        const {
            dataExcel,
            downloadXls,
        } = useSumariosToExcel(getUsAct, total, lastUrl)

        const {
            downloadXls2
        } = useSumariosToExcel2(lastUrl, total)

        const {
            order,
            setOrderBy,
            setOrder
        } = useActuacionesOrder(getData)

        const {
            prosecutorUserTypes,
            initProsecutor,
            cleanData
        } = useProsecutor()

        const {
            includesWords,
            confirmDelete
         } = useCommonMethods(resumen, ModalRefConfirmDelete, openModalTemplate, closeModalTemplate)

        return{
            //refs
            ClickAceptar,
            aceptarLabel,
            cancelarLabel,
            CategoriaUfiID,
            iconModal,
            buttomAceptar,
            buttomCancelar,
            msjEnable,
            mensaje,
            showModalForm,
            splitItems,
            disabledRowBotton,
            actualDep,
            showCalendar,
            secretario,
            ActuacionUsuarioDependencia,
            depModalSelected,
            displayBasic,
            filters,
            isFiltered,
            customName,
            data,
            customColumn,
            keyShow,
            filterActuaciones,
            filterEstados,
            filterDependencias,
            actuacionesOfOptions,
            actuacionesOf,
            disabledAsignarButton,
            denunciationsToShow,
            isUsuarioJefe,
            items,
            permisosPorUsuario,
            acciones,
            Inputs,
            forms,
            filterDropdown,
            err,
            actuacionType,
            routeID,
            ModalRefConfirm,
            ModalRefConfirmDelete,
            ModalRefInform,
            filtersFields,
            order,
            prosecutorUserTypes,
            filtersRef,
            enableFilterMultiple,

            //computed
            mostrarActuacionesRecibidas,
            getActuacionesUserByStationId,
            oficialesList,
            oficialesListModal,
            dependenciaList,
            denunciations,
            total,
            pagination,
            sumario,
            tablasListadas,
            contPag,
            formType,
            loading,
            user,
            viewData,
            lastUrl,
            dependenciaModal,
            resumen,
            depOption,
            rangoFecha,
            filterField,
            filterDropdownOptions,
            dataActuacionesOf,
            dataExcel,

            //methods
            isOfflineDoc,
            getUsAct,
            finalizarCambioEstado,
            getItems,
            confirm,
            agregarDiligencia,
            openModalTemplate,
            closeModalTemplate,
            reasignarSecretario,
            finalizarActuacion,
            vincularActuacion,
            visibleButtons,
            setXLSDropdown,
            getClass,
            goToPage,
            hasSecretary,
            booleans,
            addNsumario,
            OpenModalAddNsum,
            AsignarSecretario,
            subirActuacion,
            fechaMethod,
            assignSecretary,
            filterSecretario,
            changeNameInStore,
            seeActuacion,
            deleteActuacion,
            authorizedUser,
            siguiente,
            anterior,
            getData,
            formatDocOffline,
            formatDoc,
            setStates,
            getCausaCaratula,
            getformType,
            getDate, 
            getDendunciante,
            completeNullLabelsAndAddingID,
            showColumnOrNot,
            generateFilterOptionsForFiscalUser,
            downloadXls,
            setOrderBy,
            setOrder,
            initProsecutor,
            cleanData,
            includesWords,
            confirmDelete,
            esTipoUsuario,
            handleCleanQuery,
        }
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-secretario {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.p-datatable .p-datatable-tbody>tr>td>#sin-propietario {
  color: #d9534f;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.toolbar>div>* {
  margin-left: 10px;
}

.toolbar>.right {
  display: flex;
  flex-direction: row-reverse;
}

.declaracion {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.action-buttons {
  text-align: right;
}

.displayNone {
  display: none;
}

.pagination {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  margin: 0.143rem;
  padding: 0 0.5rem;
}

.custom-bg-red-200 {
  background-color: #ffada7;
}
.custom-text-red-800 {
  color: #8c231c;
}
.action-buttons {
  display: flex;
  align-items: center;
}
.action-button {
  margin-right: 4px; 
}

.action-splitbutton {

  padding: 0;
  min-width: 2.5rem; 
  height: 2.5rem; 
}


::v-deep .action-splitbutton .p-splitbutton-defaultbutton,
::v-deep .action-splitbutton.p-button-rounded > .p-splitbutton-defaultbutton.p-button,
::v-deep .action-splitbutton.p-button-outlined > .p-splitbutton-defaultbutton.p-button {
  display: none; 
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .action-splitbutton .p-splitbutton-menubutton .p-button-icon {
  display: none; /* Oculta el icono por defecto */
}

::v-deep .action-splitbutton .p-splitbutton-menubutton::after {
  content: '\e950'; /* Código Unicode para el nuevo icono (ejemplo: Font Awesome) */
  font-family: 'primeicons'; /* Asegúrate de que la fuente sea correcta */
  color: #5A5A5A;
}

</style>
